import { Action, ActionType } from "@redux/actionTypes/userManagementActionType";
import { Reducer } from "redux";

export interface IUserManagementListState {
  userManagementDetailsByPID: UserManagementForm[];
}

export interface UserManagementForm {
  userId: number;
  roleId: number;
  fullName: string;
  emailAddress: string;
  mobileCountryId: number;
  mobileNumber: string;
  isActive: boolean;
  isDeleted: boolean;
  designationName: string;
  mobileCountry: MobileCountry;
  masterUserBusinessUnitMappings: BusinessUnit[];
  masterUserCountryMappings: UserCountry[];
  masterUserDepartmentMappings: UserDepartment[];
  masterUserRegionMappings: UserRegion[];
}
export interface MobileCountry {
  countryId: number;
  countryName: string;
  isdcountryCode: string;
}
export interface BusinessUnit {
  businessUnitId: number;
  businessUnit: {
    businessUnitId: number;
    businessUnitName: string;
  };
}
export interface UserCountry {
  countryId: number;
  country: {
    countryId: number;
    countryName: string;
  };
}
export interface UserDepartment {
  departmentId: number;
  department: {
    departmentId: number;
    departmentName: string;
  };
}
export interface UserRegion {
  regionId: number;
  region: {
    regionId: number;
    regionName: string;
  };
}

const initialState = {
  userManagementDetailsByPID: [],
};

export const userManagementReducer: Reducer<IUserManagementListState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.USER_MANAGEMENT_DETAIL_BY_PID:
      return {
        ...state,
        userManagementDetailsByPID: action.payload,
      };
    default:
      return state;
  }
};
